import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/iamfluidics.webp';
import screenshot_target from '../../../images/letterfunnel/tomkamperman.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Tom Kamperman"
      firstname="Tom"
      companyname="IamFluidics"
      competition="Microcaps en TreeFrog Therapeutics"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/tomkamperman.js